import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Yup from 'yup';
import { StyledEngineProvider } from '@mui/material';
import App from './app/App';
import { applyMproTheme, getSavedThemeId } from './app/theme/mproThemes';
import * as serviceWorker from './serviceWorker';

// third party style
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import 'react-toastify/dist/ReactToastify.css';


// Pesan validasi form dalam Bahasa Indonesia (menggantikan pesan Inggris bawaan Yup)
Yup.setLocale({
  mixed: {
    required: 'Kolom ini wajib diisi',
    notType: ({ type }) => (type === 'number' ? 'Wajib diisi dengan angka' : type === 'date' ? 'Tanggal tidak valid' : 'Isian tidak valid'),
    oneOf: 'Pilihan tidak valid',
  },
  string: {
    min: ({ min }) => `Minimal ${min} karakter`,
    max: ({ max }) => `Maksimal ${max} karakter`,
    email: 'Format email tidak valid',
  },
  number: {
    min: ({ min }) => `Nilai minimal ${min}`,
    max: ({ max }) => `Nilai maksimal ${max}`,
    positive: 'Harus berupa angka positif',
    integer: 'Harus berupa bilangan bulat',
  },
});

// Pasang tema warna yang tersimpan sebelum React dirender (hindari kedipan warna)
applyMproTheme(getSavedThemeId(), { persist: false });

const root = createRoot(document.getElementById('root'));



root.render(
  <StyledEngineProvider injectFirst>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StyledEngineProvider>
);

// for IE-11 support un-comment cssVars() and it's import in this file
// and in MatxTheme file

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
